import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import TransportPage from '../../views/TransportPage/';

class EditVehicle extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			modyear : '',
			km : '',
			brand : '',
			model : '',
			color : '',
			vtype : '',
			driver : '',
			regno : '',
			engno : '',
			tyresize : '',
			inscomp : '',
			insno : '',
			insamt : '',
			renewalon : '',
			remarks : '',
			posts : [],
			drive : [],
			 _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('transport/update',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			console.log(responseJson);
			if(responseJson.status == '1'){
				this.setState({
					_message:'Vehicle Updated Successfullly',
					alertClass:'alert alert-success'
				});	
				document.getElementById("edvehform").reset();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	componentWillMount(){
		
		this.getdetails();
		this.getdriver();
	}
	
	/** get Driver **/
	getdriver(){
		
		GetData('employee/getdriver').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					drive : responseJson
				});
			}
		});
	}
	
	getdetails(){
		$("#showLoader").show();
		GetData('transport/getvehiclebyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					modyear : res[0]['modelyear'],
					km : res[0]['km'],
					brand : res[0]['brand'],
					model : res[0]['model'],
					color : res[0]['color'],
					vtype : res[0]['type'],
					driver : res[0]['drivername'],
					regno : res[0]['regno'],
					engno : res[0]['engineno'],
					tyresize : res[0]['tyresize'],
					inscomp : res[0]['insurancecompany'],
					insno : res[0]['insuranceno'],
					insamt : res[0]['insuranceamount'],
					renewalon : res[0]['insurancerenewal'],
					remarks : res[0]['remarks']
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/transport/vehicle' />);
	}
	
	var dri = this.state.drive;
	
	 /** set type select box **/
	this.type = [
		{value : '', name : 'Select'},
		{value : 'Car', name : 'Car'},
		{value : 'Jeep', name : 'Jeep'},
		{value : 'Bus', name : 'Bus'},
		{value : 'Van', name : 'Van'},
		{value : 'Lorry', name : 'Lorry'},
		{value : 'Truck', name : 'Truck'},
		{value : 'Motor Cycle', name : 'Motor Cycle'}
	];
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="vehform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Vehicle</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back</Button>
							</span>
						</CardHeader>
						<CardBody>
						  <Row>
						   <Col md="12">
							<div className={this.state.alertClass}>
								{this.state._message}
							</div>
							<Row>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Model Year <span className="text-danger">*</span></Label>
								  <Input type="text" name="modyear" required onChange={this.onChange} value={this.state.modyear} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Kilo Meter <span className="text-danger">*</span></Label>
								  <Input type="text" name="km" required onChange={this.onChange} value={this.state.km} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Make (Brand) <span className="text-danger">*</span></Label>
								  <Input type="text" name="brand" required onChange={this.onChange} value={this.state.brand} />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Model <span className="text-danger">*</span></Label>
								  <Input type="text" name="model" required onChange={this.onChange} value={this.state.model} />
								</FormGroup>
							  </Col>
							   <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Color <span className="text-danger">*</span></Label>
								  <Input type="text" name="color" required onChange={this.onChange} value={this.state.color} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Type <span className="text-danger">*</span></Label>
								  <Input type="text" name="vtype" required onChange={this.onChange} value={this.state.vtype} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Driver <span className="text-danger">*</span></Label>
								  <select name="driver" onChange={this.onChange} className="form-control" value={this.state.driver}> 
									<option value="">Select Driver</option>
									{
										dri.map(function (item) {
											return <option value={item.id }>{item.empname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Registration no <span className="text-danger">*</span></Label>
								  <Input type="text" name="regno" required onChange={this.onChange} value={this.state.regno} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Engine No</Label>
								  <Input type="text" name="engno" onChange={this.onChange} value={this.state.engno} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Tyre Size </Label>
								  <Input type="text" name="tyresize" onChange={this.onChange} value={this.state.tyresize} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Company </Label>
								  <Input type="text" name="inscomp" onChange={this.onChange} value={this.state.inscomp} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance No </Label>
								  <Input type="text" name="insno" onChange={this.onChange} value={this.state.insno} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Amount </Label>
								  <Input type="text" name="insamt" onChange={this.onChange} value={this.state.insamt} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Renewal on <span className="text-danger">*</span></Label>
								  <Input type="date" name="renewalon" required onChange={this.onChange} value={this.state.renewalon} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Remarks </Label>
								  <Input type="textarea" name="remarks" onChange={this.onChange} rows="5" value={this.state.remarks} />
								</FormGroup>
							  </Col>
							</Row>
						  </Col>
						 </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default EditVehicle;


// WEBPACK FOOTER //
// ./src/transport/Vehicle/EditVehicle.js